import './Components.css'
import Icon from '@mdi/react';

function Button(props) {
    const {
        variant,
        icon
    } = props

    return (<div style={{display: 'inline-block'}}><button {...props} className={variant || 'default'}>
        {icon && <Icon path={icon} className={'icon'} />}
        {props.children}
    </button></div>)
}

export default Button;